// cspell:disable

/**
 * Tracking providers that can be used to track shipments.
 */
export enum TrackingProvider {
  EASYPOST = "easypost",
  TRACK123 = "track123",
  FIRST_MILE = "first_mile",
}
